export default {
    services: {
        api: {
            uri: 'p-enterprise.com',
            // uri: 'localhost',
            port: 8000,
        },
        auth: {
            client_id: '7cbEcdXxZKxSAwyFpwwW5rGCKi6ND3bgr6zkbrPr',
            client_secret: '8NgXOBdXTaPW3UhNohQMsY9ENwj3LN2C37fSwW03BZpsnGDLyuoP8Kn69BaL5Ti4y1vhc9HgqARdOFm7tjKdoyvQEFdzwc43OLTohR9TB3AfTbJMCuKfggZnShB7T4Ca'
        },
        v2: {
            // uri: 'p-enterprise.com',
            uri: 'cms.cciofficial.com',
            // uri: 'localhost',
            port: 8002,
        }
    },
}



// WEBPACK FOOTER //
// ./src/config.js